import React, { useState, useEffect, useCallback } from "react";
import "./GoogleForm.css";

const CONSTANTS = {
  SESSION_KEYS: {
    FORM_SUBMITTED_KEY: "formSubmitted",
    THANK_YOU_SHOWN_KEY: "thankYouShown",
  },
  FORM_STATES: {
    FORM: "form",
    THANK_YOU: "thankYou",
    ALREADY_SUBMITTED: "alreadySubmitted",
  },
};

const GoogleForm = ({ action, fields, submitButtonText, title, messages, sessionStorageKeys, resetButtonText }) => {
  const { FORM_SUBMITTED_KEY, THANK_YOU_SHOWN_KEY } = sessionStorageKeys;
  const { FORM, THANK_YOU, ALREADY_SUBMITTED } = CONSTANTS.FORM_STATES;

  const getSessionState = useCallback(() => {
    const isSubmitted = sessionStorage.getItem(FORM_SUBMITTED_KEY) === "true";
    const thankYouShown = sessionStorage.getItem(THANK_YOU_SHOWN_KEY) === "true";

    if (isSubmitted && thankYouShown) return ALREADY_SUBMITTED;
    if (isSubmitted) return THANK_YOU;
    return FORM;
  }, [FORM_SUBMITTED_KEY, THANK_YOU_SHOWN_KEY, FORM, THANK_YOU, ALREADY_SUBMITTED]);

  const [formState, setFormState] = useState(() => getSessionState());

  useEffect(() => {
    const handleStorageChange = () => {
      console.log("Current session storage:", { ...sessionStorage });
      setFormState(getSessionState());
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [getSessionState]);


  useEffect(() => {
    if (formState === THANK_YOU) {
      sessionStorage.setItem(THANK_YOU_SHOWN_KEY, "true");
    }
  }, [formState, THANK_YOU_SHOWN_KEY, THANK_YOU]);

  const handleIframeLoad = () => {
    const isSubmitted = sessionStorage.getItem(FORM_SUBMITTED_KEY) === "true";

    console.log("Iframe loaded with formState and isSubmitted", formState, isSubmitted);
    // Prevent state changes if not actively submitting
    if (formState !== FORM) {
      console.log("Ignoring iframe load. Current state:", formState);
      return;
    }

    // Ensure this logic only runs for form submission
    if (formState === FORM && isSubmitted) {
      sessionStorage.setItem(FORM_SUBMITTED_KEY, "true");
      sessionStorage.setItem(THANK_YOU_SHOWN_KEY, "false");
      setFormState(THANK_YOU);
    }
  };


  useEffect(() => {
    console.log("Form state changed to:", formState);
  }, [formState]);



  const resetForm = () => {
    console.log("Clearing session storage...");
    // Clear session storage
    sessionStorage.removeItem(THANK_YOU_SHOWN_KEY);
    sessionStorage.removeItem(FORM_SUBMITTED_KEY);
    // sessionStorage.clear();

    // Trigger manual storage event to synchronize
    window.dispatchEvent(new Event("storage"));

    console.log("Session storage after clear:", sessionStorage);

    // // Query for the iframe after ensuring it is rendered
    // const iframe = document.querySelector("iframe[name='hidden_iframe']");
    // if (!iframe) {
    //   return;
    // }
  };



  if (formState === ALREADY_SUBMITTED) {
    return (
      <div className="form-submitted">
        <h3>{messages.alreadySubmitted.title}</h3>
        <p>{messages.alreadySubmitted.body}</p>
        {messages.alreadySubmitted.isResetAllowed && <button className="reset-button" onClick={resetForm}>
          {resetButtonText || "Reset Form"}
        </button>}
      </div>
    );
  }

  if (formState === THANK_YOU) {
    return (
      <div className="form-success">
        <h3>{messages.thankYou.title}</h3>
        <p>{messages.thankYou.body}</p>
        {messages.thankYou.isResetAllowed && <button className="reset-button" onClick={resetForm}>
          {resetButtonText || "Reset Form"}
        </button>}
      </div>
    );
  }
  if (formState === FORM) {
    return (
      <div className="form-container">
        <form
          action={action}
          method="POST"
          target="hidden_iframe"
          className="form"
          onSubmit={(e) => {
            sessionStorage.setItem(FORM_SUBMITTED_KEY, "true");
          }}
        >
          {title && <h3 className="form-title">{title}</h3>}
          {fields.map((field, index) => (
            <div key={index} className="form-group">
              <label htmlFor={field.name}>{field.label}:</label>
              {field.type === "textarea" ? (
                <textarea
                  id={field.name}
                  name={field.name}
                  placeholder={field.placeholder}
                  required={field.required}
                  rows="5"
                ></textarea>
              ) : (
                <input
                  type={field.type}
                  id={field.name}
                  name={field.name}
                  placeholder={field.placeholder}
                  required={field.required}
                />
              )}
            </div>
          ))}
          <button type="submit" className="submit-button">
            {submitButtonText}
          </button>
        </form>

        <iframe
          name="hidden_iframe"
          title="Google Form Submission"
          style={{ display: "none" }}
          onLoad={handleIframeLoad}
          src="about:blank"
        ></iframe>
      </div>
    );
  }
};

export default GoogleForm;